import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { selectPlanChanges } from '@core/store/plan-edit/plan-edit-session.selectors';

/** Names who made the last change, unless it was this tab's own. */
@Component({
  selector: 'app-changes-header-actions',
  imports: [TranslatePipe],
  templateUrl: './changes-header-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'min-w-0' },
  styles: ``
})
export class ChangesHeaderActionsComponent {
  private readonly changes = inject(Store).selectSignal(selectPlanChanges);

  protected readonly by = computed(() => this.changes()?.by ?? null);
  protected readonly byMachine = computed(() => {
    const via = this.by()?.via;
    return via === 'assistant' || via === 'mcp';
  });
}
